<template>
  <div>
    <public-home />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PublicHome from "@/components/PublicHome.vue";

export default {
  components: { "public-home": PublicHome },
  computed: {
    ...mapGetters({ user: "user/user" })
  }
};
</script>
